import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LookupEditComponent } from './lookupedit.component';

const routes: Routes = [
  { path: '', component: LookupEditComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LookupEditRoutingModule { }
